import { atom } from 'recoil';

export const blockListConfirmTokenState = atom({
  key: 'UnlockConfirm/TokenConfirm',
  default: {
    isConfirmed: false,
    isExpired: false,
    isLoading: true,
  },
});

export const blockListUnlockCustomerSendState = atom({
  key: 'UnlockCustomer/SendUnlock',
  default: {
    isSend: false,
    isError: false,
    isLoading: false,
  },
});

export const blockListRetryUnlockCustomerSendState = atom({
  key: 'UnlockCustomer/RetryUnlock',
  default: {
    isSend: false,
    isError: false,
    isLoading: false,
  },
});

export const searchTermState = atom({
  key: 'BlockList/searchTermState',
  default: '',
});
